import React from 'react';

// Shared spinner-border element — inline loading indicators on buttons
// across the app duplicated this markup (role, aria-hidden, the
// spinner-border-sm/margin combo) with a slightly different variant
// each time instead of sharing one implementation.
const Spinner = ({ small = true, className = '', color, children }) => (
  <span
    className={`spinner-border${small ? ' spinner-border-sm' : ''}${className ? ` ${className}` : ''}`}
    style={color ? { color } : undefined}
    role="status"
    aria-hidden={children ? undefined : true}
  >
    {children}
  </span>
);

export default Spinner;
